<template>

  <div id="page-new-producto" class="vx-card p-6">

    <vx-card card-border class="mb-4" title="Detalle del producto" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Sector *</span>
          </div>
          <div>
            <v-select class="w-full" 
              v-model="producto.valSector" 
              :options="sectoresActivos" 
              :selectable="option => option.activo === true"
              label="nombre"
              :reduce="id => `/api/val_sectors/${id.id}`" 
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Operador *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="OPERADOR" v-model="producto.operador" v-validate="'required'" name="operador"  @input="v => { producto.operador = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('operador')">{{ errors.first('operador') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Tipo cliente *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="TIPO CLIENTE" v-model="producto.tipoCliente" v-validate="'required'" name="tipoCliente"  @input="v => { producto.tipoCliente = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('tipoCliente')">{{ errors.first('tipoCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Tipo producto *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="TIPO PRODUCTO" v-model="producto.tipoProducto" v-validate="'required'" name="tipoProducto"   @input="v => { producto.tipoProducto = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('tipoProducto')">{{ errors.first('tipoProducto') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Producto *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="PRODUCTO" v-model="producto.producto" v-validate="'required'" name="producto"   @input="v => { producto.producto = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('producto')">{{ errors.first('producto') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Promoción</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="PROMOCIÓN" v-model="producto.promocion" name="promocion"   @input="v => { producto.promocion = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Importe sin promoción *</span>
          </div>
          <div>
            <currency-input 
              currency="EUR" 
              auto-decimal-mode: true
              data-vv-as="IMPORTE SIN PROMOCIÓN" 
              v-validate="{ regex: /\d{1,3}(\.\d{3})*(,\d+)?/ }" 
              name="importeSinPromocion"  
              class="vs-inputx vs-input--input normal" 
              v-model="producto.importeSinPromocion"
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Importe con promoción *</span>
          </div>
          <div>
            <currency-input 
              currency="EUR" 
              auto-decimal-mode: true
              data-vv-as="IMPORTE CON PROMOCIÓN" 
              v-validate="{ regex: /\d{1,3}(\.\d{3})*(,\d+)?/ }" 
              name="importeConPromocion"  
              class="vs-inputx vs-input--input normal" 
              v-model="producto.importeConPromocion"
            />
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Tipo tarjeta *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="TIPO TARJETA" v-model="producto.tipoTarjeta" v-validate="'required'" name="tipoTarjeta"   @input="v => { producto.tipoTarjeta = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('tipoTarjeta')">{{ errors.first('tipoTarjeta') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Sección *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="SECCIÓN" v-model="producto.seccion" v-validate="'required'" name="seccion"   @input="v => { producto.seccion= v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('seccion')">{{ errors.first('seccion') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Codigo producto</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="producto.codigoPrincipal" name="codigoPrincipal" />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Códigos productos asociados</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="producto.asociados" name="asociados" />
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Producto único *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="PRODUCTO ÚNICO" v-model="producto.unico" v-validate="'required'" name="unico"   @input="v => { producto.unico = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('unico')">{{ errors.first('unico') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Orden</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="producto.orden" name="orden" />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
        <div>
          <span>Caracteristicas del producto</span>
        </div>
          <vs-textarea class="w-full" name="caracteristicas" v-model="producto.caracteristicas" height="120px"/>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

  </div>

</template>


<script>
import valSectoresStore from '@/store/configuracion/val-sectores/index.js'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      sectoresActivos: [],
      producto: {
        valSector: '',
        operador: '',
        tipoCliente: '',
        tipoProducto: '',
        producto: '',
        importeSinPromocion: null,
        importeConPromocion: null,
        tipoTarjeta: '',
        seccion: '',
        unico: ''
      }
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() || this.producto.valSector === '' || this.producto.valSector === null || this.producto.operador === '' 
        || this.producto.tipoCliente === '' || this.producto.tipoProducto === '' || this.producto.producto === '' 
        || this.producto.importeSinPromocion === 0 || this.producto.importeSinPromocion === null || this.producto.importeConPromocion === 0 || this.producto.importeConPromocion === null 
        || this.producto.tipoTarjeta === '' || this.producto.seccion === '' || this.producto.unico === '') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

      // Como o vs-input envía sempre un string, verificamos que se ten valor o convertimos a enteiro e se non poñémolo a null para evitar que pete ao intentar gardar en BD un string
      if (this.producto.codigoPrincipal !== null && this.producto.codigoPrincipal !== '') {
        this.producto.codigoPrincipal = Number(this.producto.codigoPrincipal)
      } else {
        this.producto.codigoPrincipal = null
      }
      if (this.producto.orden !== null && this.producto.orden !== '') {
        this.producto.orden = Number(this.producto.orden)
      } else {
        this.producto.orden = null
      }

      this.$store.dispatch('valProductosStore/addProducto', this.producto)
        .then(()   => { 
          this.$router.push({name: 'valProductos'})
          this.showUpdateSuccess() 
        })
        .catch(err => { this.showUpdateError(err) })
    },
    showUpdateSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Producto creado',
        text: 'El producto ha sido creado correctamente.'
      })
    },
    showUpdateError () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: 'El producto no ha podido ser creado.'
      })
    },
    reset_data () {
      this.$router.push({name: 'valProductos'})
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    if (!valSectoresStore.isRegistered) {
      this.$store.registerModule('valSectoresStore', valSectoresStore)
      valSectoresStore.isRegistered = true
    }
    await this.$store.dispatch('valSectoresStore/getSectores')
      .then(() => {
        // Recorremos os sectores e se están activos ou se teñen o mesmo id que o que ten asociado o producto engadímolas ao combo
        this.$store.state.valSectoresStore.sectores.forEach(element => {
          if (element.activo) this.sectoresActivos.push(element)
        })
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
      .catch((error) => {
        console.log(error)
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
  }
}
</script>